import { Box, Typography } from '@iheartjane/reefer';
import { useMemo } from 'react';

import { useCheckout } from '@jane/shared-ecomm/providers';
import { getOrderingSchedule } from '@jane/shared-ecomm/util';
import { getTodaysScheduleHours } from '@jane/shared/util';

import { useReservationModeLabels } from '../util/hooks/useReservationModeLabels';

export const StoreHours = () => {
  const { store, deliveryValidation } = useCheckout();

  // if we don't have the data we just let it check against deliverySchedule
  const deliversToday = deliveryValidation?.data
    ? deliveryValidation?.data.delivers_today
    : true;

  const { curbsideLabel, deliveryLabel, pickupLabel } =
    useReservationModeLabels();

  const { curbsideSchedule, deliverySchedule, pickupSchedule } = useMemo(
    () =>
      getOrderingSchedule({
        store,
        type: ['pickup', 'delivery', 'curbside'],
      }),
    [store]
  );

  const { pickupHours, deliveryHours, curbsideHours } = getTodaysScheduleHours({
    pickup: {
      opening: pickupSchedule?.getToday()?.formattedOpeningTime,
      closing: pickupSchedule?.getToday()?.formattedClosingTime,
    },
    delivery: {
      opening: deliversToday
        ? deliverySchedule?.getToday()?.formattedOpeningTime
        : null,
      closing: deliversToday
        ? deliverySchedule?.getToday()?.formattedClosingTime
        : null,
    },
    curbside: {
      opening: curbsideSchedule?.getToday()?.formattedOpeningTime,
      closing: curbsideSchedule?.getToday()?.formattedClosingTime,
    },
  });

  if (!pickupHours && !curbsideHours && !deliveryHours) return null;

  return (
    <Box>
      <Typography color="text-light" mt={24}>
        Today's hours
      </Typography>

      {!!pickupHours && (
        <Typography>
          {pickupLabel} {pickupHours}
        </Typography>
      )}

      {!!curbsideHours && (
        <Typography>
          {curbsideLabel} {curbsideHours}
        </Typography>
      )}

      {!!deliveryHours && (
        <Typography>
          {deliveryLabel} {deliveryHours}
        </Typography>
      )}
    </Box>
  );
};
